<template>
    <div :id="idFormulario">
        <h6>Datos del representante legal de la Empresa o Institución</h6>
            <hr />
            <div class="row">
              <div class="col-12">
                <h6>
                  Nombre (*)&nbsp;
                  <i v-if="mostrarErrores && !this.cadenaEsVaciaONula(nombre)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                  <i v-if="mostrarErrores && this.cadenaEsVaciaONula(nombre)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                </h6>
                <input v-model="nombre" type="text" id="representante-empresa" :class="[mostrarErrores && this.cadenaEsVaciaONula(nombre) ? 'form-control border border-danger' : 'form-control']" placeholder="Ingrese el nombre del representante legal" />
              </div>
              <div class="col-6">
                <h6 style="margin-top: 1em;">
                  Apellido Paterno (*)&nbsp;
                  <i v-if="mostrarErrores && !this.cadenaEsVaciaONula(apellidoPaterno)" class="fas fa-check-circle text-success font-size: 15px;"></i>
                  <i v-if="mostrarErrores && this.cadenaEsVaciaONula(apellidoPaterno)" class="fas fa-times-circle text-danger font-size: 25px;"></i>
                </h6>
                <input v-model="apellidoPaterno" type="text" id="representante-apellidoPaterno" :class="[mostrarErrores && this.cadenaEsVaciaONula(apellidoPaterno) ? 'form-control border border-danger' : 'form-control']" placeholder="Ingrese el apellido paterno del representante legal" />
              </div>
              <div class="col-6">
                <h6 style="margin-top: 1em;">Apellido Materno</h6>
                <input v-model="apellidoMaterno" type="text" id="representante-apellidoMaterno" class="form-control" placeholder="Ingrese el apellido materno del representante legal" />
              </div>
            </div>              
            <div :class="[representantesLegalesTabla.length > 0 ? 'd-flex d-flex justify-content-between' : 'text-right']" style="margin-top: 2em;">
                 <div class="col-6 p-0">
                     <CTablaGenericaCedulas v-show="representantesLegalesTabla.length > 0"
                        :ref="'ref' + idFormulario + ID_TABLA_REPRESENTANTES_LEGALES"
                        :idDelInput="idFormulario + ID_TABLA_REPRESENTANTES_LEGALES"
                        :encabezadosColumnas="encabezadosColumnas"
                        :accionesEnTabla="TABLA_REPRESENTANTES_LEGALES_ACCIONES"
                        :listaDeCedulas="representantesLegalesTabla"
                        v-on:accionFuncionEliminar="evtRemoverRepresentanteTabla"
                        v-on:accionesFuncionDeEditar="evtEditarRepresentanteTabla"></CTablaGenericaCedulas>
                 </div>
                <div :class="[estaEditandoRepresentante ? 'd-flex d-flex justify-content-end' : '']">
                    <div v-if="estaEditandoRepresentante"><button type="button" @click="evtCancelarEdicion" class="btn btn-primary mr-2"><i class="fas fa-window-close"></i>&nbsp;&nbsp;Cancelar edición</button></div>
                    <div><button type="button" @click="evtAgregarRepresentante" class="btn btn-primary"><i :class="[estaEditandoRepresentante ? 'fas fa-save' : 'fas fa-plus-square']"></i>&nbsp;&nbsp;{{textoBotonGuardarOEditar}}</button></div>
                </div> 
            </div>
    </div>
</template>
<script>
import CTablaGenericaCedulas from '../Comun/CTablaGenericaCedulas.vue'
import comun from "@/../static/js/comun"
import enumeraciones from '@/../static/js/enumeraciones'

export default {
    props: {
        idFormulario: String
    },
    components: {
        CTablaGenericaCedulas: CTablaGenericaCedulas
    },
    data() {
        return {
            ID_TABLA_REPRESENTANTES_LEGALES: 'representantesLegalesTabla',
            encabezadosColumnas: ['#','Representante',''],
            TABLA_REPRESENTANTES_LEGALES_ACCIONES: {motrarAcciones: true,check: false, eliminar: true, editar: true,imprimir: false, ver: false},
            representantesLegales: [],
            representantesLegalesTabla: [],
            nombre: null,
            apellidoPaterno: null,
            apellidoMaterno: null,
            contadorRepresentantesLegales: 0,
            representanteLegalEnEdicion: null,
            estaEditandoRepresentante: false,
            mostrarErrores: false,
            textoBotonGuardarOEditar: 'Agregar Representante Legal'
        }
    },
    methods: {
        evtCancelarEdicion: function() {
            this.estaEditandoRepresentante = false;
            this.textoBotonGuardarOEditar = 'Agregar Domicilio'
            this.representanteLegalEnEdicion = null;
            this.limpiarDatosRepresentante();
        },
        evtRemoverRepresentanteTabla: function(evento) {
            const ID_REPRESENTANTE_SELECCIONADO = this.obtenerIdRepresentanteSeleccionado(evento.target.getAttribute('id'));
            let representanteSeleccionado = null;
            this.representantesLegales.filter(robj => robj.idReferencia == ID_REPRESENTANTE_SELECCIONADO).forEach(r => {
                representanteSeleccionado = r;
            });
            if(representanteSeleccionado != null) 
                this.informarConfirmacionRemoverRepresentante(representanteSeleccionado);
        },
        evtEditarRepresentanteTabla: function(evento) { debugger
            if(!this.estaEditandoRepresentante) {
                const ID_REPRESENTANTE_SELECCIONADO = this.obtenerIdRepresentanteSeleccionado(evento.target.getAttribute('id'));
                let representanteSeleccionado = null;
                this.representantesLegales.filter(robj => robj.idReferencia == ID_REPRESENTANTE_SELECCIONADO).forEach(r => {
                    representanteSeleccionado = r;
                });
                if(representanteSeleccionado != null) {
                    this.estaEditandoRepresentante = true;
                    this.asignarValoresEdicion(representanteSeleccionado);
                    this.textoBotonGuardarOEditar = 'Guardar Cambios'
                    this.mostrarErrores = false;
                }
                this.representanteLegalEnEdicion = representanteSeleccionado;
            }
            else {
                comun.mensajeDeAlerta('Actualmete te encuentras editando a un representante legal', null, null);
            }
        },
        asignarValoresEdicion: function(representanteLegal) {
            this.nombre = representanteLegal.representanteLegal.DatosGenerales.Fisica.Nombre;
            this.apellidoPaterno = representanteLegal.representanteLegal.DatosGenerales.Fisica.ApellidoPaterno;
            this.apellidoMaterno = representanteLegal.representanteLegal.DatosGenerales.Fisica.ApellidoMaterno;
        },
        obtenerIdRepresentanteSeleccionado: function(representanteSeleccionado) {
            const REPRESENTANTE = representanteSeleccionado.split('-');
            const POSICION_DE_ID = (REPRESENTANTE.length - 1);
            const ID_REPRESENTANTE = REPRESENTANTE[POSICION_DE_ID];
            return ID_REPRESENTANTE;
        },
        evtAgregarRepresentante: function() {
            if(this.formularioValido()) {
                this.agregarRepresentante();
            }
            else {
                this.mostrarErrores = true;
                comun.mensajeDeAlerta(this.cadenaEsVaciaONula(this.nombre) ? 'Se detectaron campos incorrectos, Debes ingresar un Nombre valido' : 'Se detectaron campos incorrectos, Debes ingresar un Apellido Paterno valido', null, null);
            }
        },
        formularioValido: function() {
            let esValido = false;
            if(!this.cadenaEsVaciaONula(this.nombre) && !this.cadenaEsVaciaONula(this.apellidoPaterno)) 
                esValido = true;
            return esValido;
        },
        agregarRepresentante: function() {
            let mensaje = null;
            let representante = this.obtenerObjRepresentanteLegal();
            if(this.representanteLegalEnEdicion == null) {
                this.representantesLegales.push(representante);
                this.representantesLegalesTabla.push(this.darFormatoTablaARepresentantesLegal(representante));
                mensaje = 'El representante legal se agrego correctamente'
            }
            else if(this.representanteLegalEnEdicion != null) {
                const INDEX_REPRESENTANTE_EDITADO = this.representantesLegales.findIndex(r => r.idReferencia == this.representanteLegalEnEdicion.idReferencia);
                this.representantesLegales[INDEX_REPRESENTANTE_EDITADO] = representante;
                this.representantesLegalesTabla[INDEX_REPRESENTANTE_EDITADO].Representante = this.obtenerNombreCompleto(representante);
                this.representanteLegalEnEdicion = null;
                this.textoBotonGuardarOEditar = 'Agregar Domicilio';
                mensaje = 'Los cambios del representante legal se guardaron correctamente';
            }
            this.$emit('obtenerListadoDeRepresentantesLegales', this.representantesLegales);
            this.estaEditandoRepresentante = false;
            this.limpiarDatosRepresentante();
            this.mostrarErrores = false;
            comun.mensajeDeAlerta(mensaje, null, null);
        },
        limpiarDatosRepresentante: function() {
            this.nombre = null;
            this.apellidoPaterno = null;
            this.apellidoMaterno = null;
        },
        obtenerObjRepresentanteLegal: function() {
            let objRepresentanteLegal = {};
            let representanteLegal = {};
            let datosGenerales = {};
            let fisica = {
                FisicaId: -1,
                Nombre: (!this.cadenaEsVaciaONula(this.nombre)) ? this.nombre.trim().toUpperCase() : this.nombre,
                ApellidoMaterno: (!this.cadenaEsVaciaONula(this.apellidoMaterno)) ? this.apellidoMaterno.trim().toUpperCase() : this.apellidoMaterno,
                ApellidoPaterno: (!this.cadenaEsVaciaONula(this.apellidoPaterno)) ? this.apellidoPaterno.trim().toUpperCase() : this.apellidoPaterno
            }
            datosGenerales.Fisica = fisica;
            datosGenerales.Moral = null;
            datosGenerales.TipoPersona = null;
            representanteLegal.DatosGenerales = datosGenerales;
            representanteLegal.TipoPersona = {
              TipoPersonaId: enumeraciones.pj.tiposPersonas.Fisica
            }
            objRepresentanteLegal.idReferencia = (this.representanteLegalEnEdicion != null) ? this.representanteLegalEnEdicion.idReferencia :this.contadorRepresentantesLegales += 1;
            objRepresentanteLegal.representanteLegal = representanteLegal;
            return objRepresentanteLegal;
        },
        darFormatoTablaARepresentantesLegal: function(representanteLegal) {
            let representante = {};
            representante.Folio = representanteLegal.idReferencia;
            representante.Representante = this.obtenerNombreCompleto(representanteLegal);
            return representante;
        },
        obtenerNombreCompleto: function(representanteLegal) {
            const DATOS_NOMBRE = [representanteLegal.representanteLegal.DatosGenerales.Fisica.Nombre, representanteLegal.representanteLegal.DatosGenerales.Fisica.ApellidoPaterno, representanteLegal.representanteLegal.DatosGenerales.Fisica.ApellidoMaterno]
            const NOMBRE_COMPLETO = DATOS_NOMBRE.join(' ');
            return NOMBRE_COMPLETO;
        },
        cadenaEsVaciaONula: function(campo) {
            /* let esVaciaONula = false;
            if(cadena == null || cadena == '' || cadena == undefined) {
                esVaciaONula = true;
            }
            return esVaciaONula; */
            let esValido = true
            if(typeof campo === 'string' || campo instanceof String) {
                // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                    esValido = false;
                }
            }
            else if (typeof campo === 'number' || campo instanceof Number) {
                // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                if (campo != null && campo != undefined && campo > 0) {
                    esValido = false;
                }
            }
            else {
                if (campo != null && campo != undefined) {
                    esValido = false;
                }
            }
            return esValido;
        },
        informarConfirmacionRemoverRepresentante: function (representante) {
            bootbox.confirm({
                title: "Mensaje del sistema",
                message: `Estas seguro que deseas remover el representante legal<br>¿Desea continuar?`,
                buttons: {
                    cancel: {
                        label: '<i class="fa fa-times"></i>&nbsp;&nbsp;Cancelar'
                    },
                    confirm: {
                        label: '<i class="fa fa-check"></i>&nbsp;&nbsp;Aceptar'
                    }
                },
                callback: (respuesta) => {
                    if (respuesta) {
                        const INDEX_REPRESENTANTE_REMOVER = this.representantesLegales.findIndex(r => r.idReferencia == representante.idReferencia);
                        this.removerRepresentante(this.representantesLegales, INDEX_REPRESENTANTE_REMOVER);
                        this.removerRepresentante(this.representantesLegalesTabla, INDEX_REPRESENTANTE_REMOVER);
                        if(this.representanteLegalEnEdicion != null && this.representanteLegalEnEdicion.idReferencia == representante.idReferencia) {
                            this.limpiarDatosRepresentante();
                            this.mostrarErrores = false;
                            this.estaEditandoRepresentante = false;
                            this.representanteLegalEnEdicion = null;
                            this.textoBotonGuardarOEditar = 'Agregar Representante Legal';
                        }
                        if(this.representantesLegalesTabla.length < 1) 
                            this.contadorRepresentantesLegales = 0;
                        this.$emit('obtenerListadoDeRepresentantesLegales', this.representantesLegales);
                    }
                }
            });
        },
        removerRepresentante: function(removerEn, indexRepresentanteRemover) {
            removerEn.splice(indexRepresentanteRemover,1);
        }
    },
    watch: {
        representantesLegalesTabla() {
            if(this.representantesLegalesTabla.length > 1) {
                this.$refs['ref' + this.idFormulario + this.ID_TABLA_REPRESENTANTES_LEGALES].cedulasAmostrarPorPagina = 2;
            }
        },
        estaEditandoRepresentante() {}
    }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CFormularioRepresentantesLegales.vue